import React, { Component, Fragment } from "react";
// import Footer from "../utilities/Footer";
import AppContext from "../../contexts/AppContext";
// import NoData from "../utilities/NoData";
// import LoadingData from "../utilities/LoadingData";
import { records as writerJobs } from "../../services/writerJob";
import { payPlan as writerPlan } from "../../services/writerPlan";
import Header from "./Header";
//import Header from "./account/Header";
import CollapseMenu from "./CollapseMenu";
import Posts from "../blog/Posts";
import { profileStatistic } from "../../services/user";
import { Link } from "react-router-dom";

class Dashboard extends Component {
    state = {
        jobs: [],
        plan: {},
        welcome: false,
        collapseMenu: false,
        profileStatistic: {}
    };

    componentDidMount() {
        writerJobs(1)
            .then(response => {
                this.setState({
                    jobs: response.data
                });
            })
            .catch(error => {
                this.context.state.handelError(error);
            });

        let temp = JSON.parse(localStorage.getItem("welcome"));
        if (temp) {
            this.setState({ welcome: temp });
        }

        writerPlan()
            .then(response => {
                this.setState({
                    plan: response.data
                });
            })
            .catch(error => {
                this.context.state.handelError(error);
            });

        profileStatistic()
            .then(response => {
                this.setState({
                    profileStatistic: response.data
                });
            })
            .catch(error => {
                this.context.state.handelError(error);
            });
    }

    hideWelcome = () => {
        this.setState({ welcome: false });
        localStorage.setItem("welcome", JSON.stringify({ welcome: false }));
    };

    render() {
        const user = this.context.state.user;

        return (
            <Fragment>
                <Header></Header>
                <div className="main-content mt-6">
                    <div className="container pt-5">
                        <div className="row">
                            <div className="col-12 col-xl-4 col-md-4">
                                <div className="card text-center">
                                    <div className="align-items-center  my-4">
                                        <div className="col">
                                            <div className="avatar avatar-xl">
                                                <img
                                                    src={user.image}
                                                    alt=""
                                                    className="avatar-img rounded-circle"
                                                />
                                            </div>
                                        </div>
                                        <div className="col mt-2">
                                            <h4>
                                                <Link
                                                    to={`/writer/dashboard`}
                                                >{`${user.first_name} ${user.last_name}`}</Link>
                                            </h4>
                                        </div>
                                    </div>
                                    <div className="col-auto"></div>

                                    <div className="card-body">
                                        <hr />

                                        <div className="d-flex justify-content-between">
                                            <p className="card-text mb-0">
                                                Applied Jobs
                                            </p>
                                            <p className="text-muted mb-0">
                                                <Link
                                                    to={`/writer/applications`}
                                                >
                                                    {
                                                        this.state
                                                            .profileStatistic
                                                            .applied_jobs_count
                                                    }
                                                </Link>
                                            </p>
                                        </div>
                                        <hr />

                                        <div className="d-flex justify-content-between">
                                            <p className="card-text mb-0">
                                                Open Jobs
                                            </p>
                                            <p className="text-muted mb-0">
                                                <Link to={`/writer/clients`}>
                                                    {
                                                        this.state
                                                            .profileStatistic
                                                            .open_Jobs
                                                    }
                                                </Link>
                                            </p>
                                        </div>
                                        <hr />

                                        <div className="d-flex justify-content-between">
                                            <p className="card-text mb-0">
                                                Portfolio Visitors
                                            </p>
                                            <p className="text-muted mb-0">
                                                <Link to={`/writer/visitors`}>
                                                    {
                                                        this.state
                                                            .profileStatistic
                                                            .portfolio_visitors
                                                    }
                                                </Link>
                                            </p>
                                        </div>
                                    </div>
                                </div>

                                {this.state.collapseMenu === true ? <CollapseMenu></CollapseMenu> : ''}
                                {this.context.state.user.state ===
                                "approved" ? (
                                    <div class="card">
                                        <a class="">
                                            <img
                                                class="card-img-top"
                                                src="/images/promotion.jpg"
                                                alt=""
                                            ></img>
                                        </a>
                                        <div class="card-body">
                                            <div class="row align-items-center">
                                                <div class="col text-left">
                                                    <h4
                                                        style={{ width: 200 }}
                                                        class="card-title mb-1"
                                                    >
                                                        Join{" "}
                                                        {this.state.plan.name}
                                                    </h4>

                                                    <span class="badge badge-soft-success">
                                                        Now just
                                                    </span>

                                                    <small class="text-muted">
                                                        ${this.state.plan.price}
                                                        /month
                                                    </small>
                                                </div>
                                                <div class="col-auto">
                                                    <Link
                                                        to={`/writer/membership`}
                                                        class="btn btn-sm btn-white"
                                                    >
                                                        Join now
                                                    </Link>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                ) : null}
                                <Posts></Posts>
                            </div>
                            <div className="col-12 col-xl-8 col-md-8">
                                {this.state.welcome === true ? (
                                    <div className="card">
                                        <div className="card-body text-center">
                                            <div className="row justify-content-center">
                                                <div className="col-12 col-md-10 col-xl-8">
                                                    <div>
                                                        <img
                                                            src="/images/willconePage.png"
                                                            alt=""
                                                            className="img-fluid mt-n5 mb-4"
                                                        />

                                                        <h2>
                                                            Welcome to
                                                            ProWriter!
                                                        </h2>

                                                        <p className="text-muted">
                                                            Show off your
                                                            experience and
                                                            competencies in your
                                                            FREE ProWriter
                                                            portfolio to start
                                                            earning new writing
                                                            jobs today!
                                                        </p>

                                                        <div>
                                                            <a
                                                                target="_Blank"
                                                                href={`/pw/${user.url}`}
                                                                className="btn btn-primary lift"
                                                            >
                                                                Complete
                                                                portfolio →
                                                            </a>
                                                        </div>
                                                        <div className="mt-4">
                                                            <a
                                                                onClick={
                                                                    this
                                                                        .hideWelcome
                                                                }
                                                                className="text-black-50"
                                                                type="text"
                                                            >
                                                                <u>
                                                                    Don’t show
                                                                    me this
                                                                    again
                                                                </u>
                                                            </a>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                ) : null}

                                <div className="card text-left">
                                    <div className="card-header">
                                        <div className="col-auto">
                                            <h4 className="card-header-title">
                                                Latest Job Listings
                                            </h4>
                                        </div>
                                        <div className="col-auto text-right">
                                            <a
                                                target="_blank"
                                                className="small"
                                                href="/jobs/"
                                            >
                                                View all
                                            </a>
                                        </div>
                                    </div>
                                    <div className="table-responsive mb-0">
                                        <table className="table table-sm table-nowrap card-table dashjobListing">
                                            <thead>
                                                <tr>
                                                    <th>Title</th>
                                                    <th>Industry</th>
                                                    <th>&nbsp;</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {this.state.jobs.map(
                                                    (item, index) => {
                                                        return (
                                                            <tr>
                                                                <td>
                                                                    <a
                                                                        target="_blank"
                                                                        href={`/${item.link}`}
                                                                    >
                                                                        {
                                                                            item.title
                                                                        }
                                                                    </a>
                                                                </td>                                                                
                                                                <td>
                                                                    <p>
                                                                        {
                                                                            item
                                                                                .industry
                                                                                .name
                                                                        }
                                                                    </p>
                                                                </td>
                                                                <td>
                                                                <a
                                                                        target="_blank"
                                                                        href={`/${item.link}`}
                                                                        className='applyBtn'
                                                                    >
                                                                       Apply
                                                                    </a>
                                                                </td>
                                                            </tr>
                                                        );
                                                    }
                                                )}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Fragment>
        );
    }
}
Dashboard.contextType = AppContext;
export default Dashboard;



// WEBPACK FOOTER //
// ./src/components/writer/Dashboard.js